// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from './client.gen';
export const apiAuthEduteamsCompleteRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/eduteams/complete/',
        ...options
    });
};
/**
 * Redirect user to OIDC authorization endpoint
 */
export const apiAuthEduteamsInitRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/eduteams/init/',
        ...options
    });
};
export const apiAuthKeycloakCompleteRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/keycloak/complete/',
        ...options
    });
};
/**
 * Redirect user to OIDC authorization endpoint
 */
export const apiAuthKeycloakInitRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/keycloak/init/',
        ...options
    });
};
/**
 * Logout from the system. If single logout is supported, returns logout URL.
 */
export const apiAuthLogout = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api-auth/logout/',
        ...options
    });
};
export const apiAuthPassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api-auth/password/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const apiAuthSaml2Login = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api-auth/saml2/login/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const apiAuthSaml2LoginComplete = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api-auth/saml2/login/complete/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const apiAuthSaml2LogoutRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/saml2/logout/',
        ...options
    });
};
/**
 * For IdPs which send GET requests
 */
export const apiAuthSaml2LogoutCompleteRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/saml2/logout/complete/',
        ...options
    });
};
/**
 * For IdPs which send POST requests
 */
export const apiAuthSaml2LogoutComplete = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/api-auth/saml2/logout/complete/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const apiAuthSaml2ProvidersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api-auth/saml2/providers/',
        ...options
    });
};
export const apiAuthTaraCompleteRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/tara/complete/',
        ...options
    });
};
/**
 * Redirect user to OIDC authorization endpoint
 */
export const apiAuthTaraInitRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api-auth/tara/init/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const accessSubnetsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/',
        ...options
    });
};
export const accessSubnetsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const accessSubnetsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/{uuid}/',
        ...options
    });
};
export const accessSubnetsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/{uuid}/',
        ...options
    });
};
export const accessSubnetsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const accessSubnetsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/access-subnets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const adminAnnouncementsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/',
        ...options
    });
};
export const adminAnnouncementsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminAnnouncementsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/{uuid}/',
        ...options
    });
};
export const adminAnnouncementsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/{uuid}/',
        ...options
    });
};
export const adminAnnouncementsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const adminAnnouncementsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin-announcements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const authTokensList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth-tokens/',
        ...options
    });
};
export const authTokensDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth-tokens/{user_id}/',
        ...options
    });
};
export const authTokensRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth-tokens/{user_id}/',
        ...options
    });
};
export const authValimoCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth-valimo/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 *
 * To get PKI login status and details - issue post request against /api/auth-valimo/result/
 * with uuid in parameters.
 *
 * Possible states:
 * - Scheduled - login process is scheduled
 * - Processing - login is in progress
 * - OK - login was successful. Response will contain token.
 * - Canceled - login was canceled by user or timed out. Field details will contain additional info.
 * - Erred - unexpected exception happened during login process.
 *
 */
export const authValimoResult = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth-valimo/result/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const autoprovisioningRulePlansList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/',
        ...options
    });
};
export const autoprovisioningRulePlansCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const autoprovisioningRulePlansDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/{uuid}/',
        ...options
    });
};
export const autoprovisioningRulePlansRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/{uuid}/',
        ...options
    });
};
export const autoprovisioningRulePlansPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const autoprovisioningRulePlansUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rule-plans/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const autoprovisioningRulesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/',
        ...options
    });
};
export const autoprovisioningRulesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const autoprovisioningRulesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/{uuid}/',
        ...options
    });
};
export const autoprovisioningRulesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/{uuid}/',
        ...options
    });
};
export const autoprovisioningRulesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const autoprovisioningRulesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/autoprovisioning-rules/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const awsImagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-images/',
        ...options
    });
};
export const awsImagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-images/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const awsInstancesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/',
        ...options
    });
};
export const awsInstancesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsInstancesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/',
        ...options
    });
};
export const awsInstancesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/',
        ...options
    });
};
export const awsInstancesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsInstancesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsInstancesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/pull/',
        ...options
    });
};
export const awsInstancesResize = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/resize/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsInstancesRestart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/restart/',
        ...options
    });
};
export const awsInstancesStart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/start/',
        ...options
    });
};
export const awsInstancesStop = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/stop/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const awsInstancesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-instances/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const awsRegionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-regions/',
        ...options
    });
};
export const awsRegionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-regions/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const awsSizesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-sizes/',
        ...options
    });
};
export const awsSizesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-sizes/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const awsVolumesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/',
        ...options
    });
};
export const awsVolumesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsVolumesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/',
        ...options
    });
};
export const awsVolumesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/',
        ...options
    });
};
export const awsVolumesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/',
        ...options
    });
};
export const awsVolumesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsVolumesAttach = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/attach/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const awsVolumesDetach = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/detach/',
        ...options
    });
};
export const awsVolumesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const awsVolumesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/aws-volumes/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureImagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-images/',
        ...options
    });
};
export const azureImagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-images/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureLocationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-locations/',
        ...options
    });
};
export const azureLocationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-locations/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azurePublicIpsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/',
        ...options
    });
};
export const azurePublicIpsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azurePublicIpsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/',
        ...options
    });
};
export const azurePublicIpsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/',
        ...options
    });
};
export const azurePublicIpsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azurePublicIpsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azurePublicIpsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const azurePublicIpsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-public-ips/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureResourceGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-resource-groups/',
        ...options
    });
};
export const azureResourceGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-resource-groups/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureSizesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sizes/',
        ...options
    });
};
export const azureSizesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sizes/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureSqlDatabasesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/',
        ...options
    });
};
export const azureSqlDatabasesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlDatabasesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/',
        ...options
    });
};
export const azureSqlDatabasesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/',
        ...options
    });
};
export const azureSqlDatabasesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlDatabasesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlDatabasesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const azureSqlDatabasesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-databases/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureSqlServersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/',
        ...options
    });
};
export const azureSqlServersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlServersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/',
        ...options
    });
};
export const azureSqlServersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/',
        ...options
    });
};
export const azureSqlServersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlServersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlServersCreateDatabase = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/create_database/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureSqlServersPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const azureSqlServersUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-sql-servers/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const azureVirtualmachinesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/',
        ...options
    });
};
export const azureVirtualmachinesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureVirtualmachinesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/',
        ...options
    });
};
export const azureVirtualmachinesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/',
        ...options
    });
};
export const azureVirtualmachinesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureVirtualmachinesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const azureVirtualmachinesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/pull/',
        ...options
    });
};
export const azureVirtualmachinesRestart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/restart/',
        ...options
    });
};
export const azureVirtualmachinesStart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/start/',
        ...options
    });
};
export const azureVirtualmachinesStop = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/stop/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const azureVirtualmachinesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/azure-virtualmachines/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const backendResourceRequestsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/',
        ...options
    });
};
export const backendResourceRequestsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const backendResourceRequestsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/{uuid}/',
        ...options
    });
};
export const backendResourceRequestsSetDone = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/{uuid}/set_done/',
        ...options
    });
};
export const backendResourceRequestsSetErred = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/{uuid}/set_erred/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const backendResourceRequestsStartProcessing = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resource-requests/{uuid}/start_processing/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const backendResourcesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resources/',
        ...options
    });
};
export const backendResourcesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resources/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const backendResourcesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resources/{uuid}/',
        ...options
    });
};
export const backendResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resources/{uuid}/',
        ...options
    });
};
export const backendResourcesImportResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/backend-resources/{uuid}/import_resource/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const billingTotalCostRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/billing-total-cost/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const bookingOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-offerings/',
        ...options
    });
};
export const bookingOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-offerings/{uuid}/',
        ...options
    });
};
export const bookingOfferingsGoogleCalendarSync = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-offerings/{uuid}/google_calendar_sync/',
        ...options
    });
};
export const bookingOfferingsShareGoogleCalendar = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-offerings/{uuid}/share_google_calendar/',
        ...options
    });
};
export const bookingOfferingsUnshareGoogleCalendar = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-offerings/{uuid}/unshare_google_calendar/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const bookingResourcesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-resources/',
        ...options
    });
};
export const bookingResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-resources/{uuid}/',
        ...options
    });
};
export const bookingResourcesAccept = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-resources/{uuid}/accept/',
        ...options
    });
};
export const bookingResourcesReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/booking-resources/{uuid}/reject/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const broadcastMessageTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/',
        ...options
    });
};
export const broadcastMessageTemplatesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const broadcastMessageTemplatesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/{uuid}/',
        ...options
    });
};
export const broadcastMessageTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/{uuid}/',
        ...options
    });
};
export const broadcastMessageTemplatesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const broadcastMessageTemplatesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-message-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const broadcastMessagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/',
        ...options
    });
};
export const broadcastMessagesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const broadcastMessagesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/',
        ...options
    });
};
export const broadcastMessagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/',
        ...options
    });
};
export const broadcastMessagesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const broadcastMessagesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const broadcastMessagesSchedule = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/schedule/',
        ...options
    });
};
export const broadcastMessagesSend = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/{uuid}/send/',
        ...options
    });
};
export const broadcastMessagesRecipientsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/broadcast-messages/recipients/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const callManagingOrganisationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/',
        ...options
    });
};
export const callManagingOrganisationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callManagingOrganisationsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/',
        ...options
    });
};
export const callManagingOrganisationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/',
        ...options
    });
};
export const callManagingOrganisationsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callManagingOrganisationsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callManagingOrganisationsAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callManagingOrganisationsDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callManagingOrganisationsListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/list_users/',
        ...options
    });
};
/**
 * Return statistics for call managing organisation.
 */
export const callManagingOrganisationsStatsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/stats/',
        ...options
    });
};
export const callManagingOrganisationsUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-managing-organisations/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const callProposalProjectRoleMappingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/',
        ...options
    });
};
export const callProposalProjectRoleMappingsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callProposalProjectRoleMappingsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/{uuid}/',
        ...options
    });
};
export const callProposalProjectRoleMappingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/{uuid}/',
        ...options
    });
};
export const callProposalProjectRoleMappingsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const callProposalProjectRoleMappingsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-proposal-project-role-mappings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const callRoundsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-rounds/',
        ...options
    });
};
export const callRoundsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-rounds/{uuid}/',
        ...options
    });
};
/**
 * Return list of reviewers for round.
 */
export const callRoundsReviewersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/call-rounds/{uuid}/reviewers/',
        ...options
    });
};
export const celeryStatsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/celery-stats/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const componentUserUsageLimitsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/',
        ...options
    });
};
export const componentUserUsageLimitsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const componentUserUsageLimitsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/{uuid}/',
        ...options
    });
};
export const componentUserUsageLimitsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/{uuid}/',
        ...options
    });
};
export const componentUserUsageLimitsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const componentUserUsageLimitsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/component-user-usage-limits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Retrieve public settings
 */
export const configurationRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/configuration/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const customerCreditsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/',
        ...options
    });
};
export const customerCreditsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customerCreditsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/',
        ...options
    });
};
export const customerCreditsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/',
        ...options
    });
};
export const customerCreditsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customerCreditsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customerCreditsApplyCompensations = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/apply_compensations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customerCreditsClearCompensations = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/clear_compensations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Get credit consumption history grouped by month.
 */
export const customerCreditsConsumptionsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-credits/{uuid}/consumptions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const customerPermissionsReviewsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-permissions-reviews/',
        ...options
    });
};
export const customerPermissionsReviewsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-permissions-reviews/{uuid}/',
        ...options
    });
};
/**
 * Close customer permission review.
 */
export const customerPermissionsReviewsClose = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-permissions-reviews/{uuid}/close/',
        ...options
    });
};
/**
 * List customer quotas.
 */
export const customerQuotasList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customer-quotas/',
        ...options
    });
};
/**
 * To get a list of customers, run GET against /api/customers/ as authenticated user. Note that a user can
 * only see connected customers:
 *
 * - customers that the user owns
 * - customers that have a project where user has a role
 *
 * Staff also can filter customers by user UUID, for example /api/customers/?user_uuid=<UUID>
 *
 * Staff also can filter customers by exists accounting_start_date, for example:
 *
 * The first category:
 * /api/customers/?accounting_is_running=True
 * has accounting_start_date empty (i.e. accounting starts at once)
 * has accounting_start_date in the past (i.e. has already started).
 *
 * Those that are not in the first:
 * /api/customers/?accounting_is_running=False # exists accounting_start_date
 */
export const customersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/',
        ...options
    });
};
/**
 * A new customer can only be created by users with staff privilege
 */
export const customersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceChecklistsCustomerRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customer_uuid}/marketplace-checklists/',
        ...options
    });
};
export const marketplaceChecklistsCustomerUpdate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customer_uuid}/marketplace-checklists/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceChecklistsCustomerStats = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{customer_uuid}/marketplace-checklists/{checklist_uuid}/',
        ...options
    });
};
/**
 * If a customer has connected projects, deletion request will fail with 409 response code.
 */
export const customersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/',
        ...options
    });
};
export const customersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/',
        ...options
    });
};
export const customersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customersAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customersDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customersListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/list_users/',
        ...options
    });
};
/**
 * Return statistics about customer resources usage
 */
export const customersStatsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/stats/',
        ...options
    });
};
/**
 * Update organization groups for customer
 */
export const customersUpdateOrganizationGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/update_organization_groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const customersUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * A list of users connected to the customer.
 */
export const customersUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/{uuid}/users/',
        ...options
    });
};
/**
 * Return list of countries
 */
export const customersCountriesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/customers/countries/',
        ...options
    });
};
export const dailyQuotasRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/daily-quotas/',
        ...options
    });
};
export const databaseStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/database-stats/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const digitaloceanDropletsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/',
        ...options
    });
};
export const digitaloceanDropletsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const digitaloceanDropletsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/',
        ...options
    });
};
export const digitaloceanDropletsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/',
        ...options
    });
};
export const digitaloceanDropletsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const digitaloceanDropletsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const digitaloceanDropletsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/pull/',
        ...options
    });
};
/**
 * To resize droplet, submit a POST request to the instance URL, specifying URI of a target size.
 *
 * Pass {'disk': true} along with target size in order to perform permanent resizing,
 * which allows you to resize your disk space as well as CPU and RAM.
 * After increasing the disk size, you will not be able to decrease it.
 *
 * Pass {'disk': false} along with target size in order to perform flexible resizing,
 * which only upgrades your CPU and RAM. This option is reversible.
 *
 * Note that instance must be OFFLINE.
 */
export const digitaloceanDropletsResize = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/resize/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const digitaloceanDropletsRestart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/restart/',
        ...options
    });
};
export const digitaloceanDropletsStart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/start/',
        ...options
    });
};
export const digitaloceanDropletsStop = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/stop/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const digitaloceanDropletsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-droplets/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const digitaloceanImagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-images/',
        ...options
    });
};
export const digitaloceanImagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-images/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const digitaloceanRegionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-regions/',
        ...options
    });
};
export const digitaloceanRegionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-regions/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const digitaloceanSizesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-sizes/',
        ...options
    });
};
export const digitaloceanSizesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/digitalocean-sizes/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const emailLogsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/email-logs/',
        ...options
    });
};
export const emailLogsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/email-logs/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const eventSubscriptionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/event-subscriptions/',
        ...options
    });
};
export const eventSubscriptionsCreate = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/event-subscriptions/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const eventSubscriptionsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/event-subscriptions/{uuid}/',
        ...options
    });
};
export const eventSubscriptionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/event-subscriptions/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const eventsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const eventsStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events-stats/',
        ...options
    });
};
export const eventsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events/{id}/',
        ...options
    });
};
export const eventsCountRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events/count/',
        ...options
    });
};
/**
 * Returns a list of groups with event types.
 * Group is used in exclude_features query param.
 */
export const eventsEventGroupsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events/event_groups/',
        ...options
    });
};
/**
 * Returns a list of scope types acceptable by events filter.
 */
export const eventsScopeTypesRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/events/scope_types/',
        ...options
    });
};
/**
 * Override feature values
 */
export const featureValues = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/feature-values/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const financialReportsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/financial-reports/',
        ...options
    });
};
export const financialReportsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/financial-reports/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const freeipaProfilesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/',
        ...options
    });
};
export const freeipaProfilesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const freeipaProfilesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/{uuid}/',
        ...options
    });
};
export const freeipaProfilesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/{uuid}/',
        ...options
    });
};
export const freeipaProfilesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update SSH keys for profile.
 */
export const freeipaProfilesUpdateSshKeys = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/freeipa-profiles/{uuid}/update_ssh_keys/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const googleAuthList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/google-auth/',
        ...options
    });
};
export const googleAuthRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/google-auth/{uuid}/',
        ...options
    });
};
export const googleAuthAuthorizeRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/google-auth/{uuid}/authorize/',
        ...options
    });
};
/**
 * Callback endpoint for Google authorization.
 */
export const googleAuthCallbackRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/google-auth/callback/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const hooksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const hooksEmailList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/',
        ...options
    });
};
export const hooksEmailCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const hooksEmailDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/{uuid}/',
        ...options
    });
};
export const hooksEmailRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/{uuid}/',
        ...options
    });
};
export const hooksEmailPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const hooksEmailUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-email/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const hooksWebList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/',
        ...options
    });
};
/**
 * When hook is activated, POST request is issued against destination URL with the following data:
 *
 * .. code-block:: javascript
 *
 * {
 * "timestamp": "2015-07-14T12:12:56.000000",
 * "message": "Customer ABC LLC has been updated.",
 * "type": "customer_update_succeeded",
 * "context": {
 * "user_native_name": "Walter Lebrowski",
 * "customer_contact_details": "",
 * "user_username": "Walter",
 * "user_uuid": "1c3323fc4ae44120b57ec40dea1be6e6",
 * "customer_uuid": "4633bbbb0b3a4b91bffc0e18f853de85",
 * "ip_address": "8.8.8.8",
 * "user_full_name": "Walter Lebrowski",
 * "customer_abbreviation": "ABC LLC",
 * "customer_name": "ABC LLC"
 * },
 * "levelname": "INFO"
 * }
 *
 * Note that context depends on event type.
 */
export const hooksWebCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const hooksWebDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/{uuid}/',
        ...options
    });
};
export const hooksWebRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/{uuid}/',
        ...options
    });
};
export const hooksWebPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const hooksWebUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/hooks-web/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const identityProvidersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/',
        ...options
    });
};
export const identityProvidersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const identityProvidersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/{provider}/',
        ...options
    });
};
export const identityProvidersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/{provider}/',
        ...options
    });
};
export const identityProvidersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/{provider}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const identityProvidersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/identity-providers/{provider}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const invoiceItemsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/',
        ...options
    });
};
export const invoiceItemsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/',
        ...options
    });
};
export const invoiceItemsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/',
        ...options
    });
};
export const invoiceItemsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const invoiceItemsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const invoiceItemsConsumptionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/consumptions/',
        ...options
    });
};
/**
 * Create compensation invoice item for selected invoice item.
 */
export const invoiceItemsCreateCompensation = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/create_compensation/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Move invoice item from one invoice to another one.
 */
export const invoiceItemsMigrateTo = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/{uuid}/migrate_to/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Get costs breakdown for a project by year and month.
 */
export const invoiceItemsCostsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/costs/',
        ...options
    });
};
export const invoiceItemsCustomerCostsForPeriodRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/customer_costs_for_period/',
        ...options
    });
};
/**
 * Get resource cost breakdown for a project over a specified period.
 */
export const invoiceItemsProjectCostsForPeriodRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/project_costs_for_period/',
        ...options
    });
};
/**
 * Calculate total price for filtered invoice items.
 */
export const invoiceItemsTotalPriceRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice-items/total_price/',
        ...options
    });
};
export const invoiceSendFinancialReportByMail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoice/send-financial-report-by-mail/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const invoicesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/',
        ...options
    });
};
export const invoicesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/',
        ...options
    });
};
/**
 * Get invoice items
 * Retrieve a list of invoice items for the specified invoice.
 */
export const invoicesItemsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/items/',
        ...options
    });
};
/**
 * Mark invoice as paid and optionally create payment record with proof of payment.
 */
export const invoicesPaid = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/paid/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Send invoice notification
 * Schedule sending of a notification for the specified invoice.
 */
export const invoicesSendNotification = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/send_notification/',
        ...options
    });
};
/**
 * Set backend ID for invoice.
 */
export const invoicesSetBackendId = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/set_backend_id/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set payment URL for invoice.
 */
export const invoicesSetPaymentUrl = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/set_payment_url/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set reference number for invoice.
 */
export const invoicesSetReferenceNumber = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/set_reference_number/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Spendings grouped by offerings and filtered by provider.
 */
export const invoicesStatsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/{uuid}/stats/',
        ...options
    });
};
/**
 * Analyze invoice trends over time by comparing monthly totals for major customers versus others over the past year.
 */
export const invoicesGrowthRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invoices/growth/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const keycloakGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-groups/',
        ...options
    });
};
export const keycloakGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-groups/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const keycloakUserGroupMembershipsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/',
        ...options
    });
};
export const keycloakUserGroupMembershipsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const keycloakUserGroupMembershipsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/{uuid}/',
        ...options
    });
};
export const keycloakUserGroupMembershipsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/{uuid}/',
        ...options
    });
};
export const keycloakUserGroupMembershipsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const keycloakUserGroupMembershipsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keycloak-user-group-memberships/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const keysList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keys/',
        ...options
    });
};
export const keysCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keys/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const keysDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keys/{uuid}/',
        ...options
    });
};
export const keysRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/keys/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const lexisLinksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/',
        ...options
    });
};
export const lexisLinksCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const lexisLinksDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/{uuid}/',
        ...options
    });
};
export const lexisLinksRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/{uuid}/',
        ...options
    });
};
export const lexisLinksPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const lexisLinksUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/lexis-links/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceBookingsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-bookings/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoriesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/',
        ...options
    });
};
export const marketplaceCategoriesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoriesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/{uuid}/',
        ...options
    });
};
export const marketplaceCategoriesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/{uuid}/',
        ...options
    });
};
export const marketplaceCategoriesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoriesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-categories/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoryColumnsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/',
        ...options
    });
};
export const marketplaceCategoryColumnsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryColumnsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/{uuid}/',
        ...options
    });
};
export const marketplaceCategoryColumnsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/{uuid}/',
        ...options
    });
};
export const marketplaceCategoryColumnsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryColumnsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-columns/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoryComponentUsagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-component-usages/',
        ...options
    });
};
export const marketplaceCategoryComponentUsagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-component-usages/{id}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoryComponentsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/',
        ...options
    });
};
export const marketplaceCategoryComponentsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryComponentsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/{id}/',
        ...options
    });
};
export const marketplaceCategoryComponentsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/{id}/',
        ...options
    });
};
export const marketplaceCategoryComponentsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryComponentsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-components/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoryGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/',
        ...options
    });
};
export const marketplaceCategoryGroupsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryGroupsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/{uuid}/',
        ...options
    });
};
export const marketplaceCategoryGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/{uuid}/',
        ...options
    });
};
export const marketplaceCategoryGroupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryGroupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCategoryHelpArticlesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/',
        ...options
    });
};
export const marketplaceCategoryHelpArticlesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryHelpArticlesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/{id}/',
        ...options
    });
};
export const marketplaceCategoryHelpArticlesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/{id}/',
        ...options
    });
};
export const marketplaceCategoryHelpArticlesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCategoryHelpArticlesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-category-help-articles/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsCategoriesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists-categories/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsCategoriesChecklistsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists-categories/{category_uuid}/checklists/',
        ...options
    });
};
export const marketplaceChecklistsCategoriesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists-categories/{uuid}/',
        ...options
    });
};
export const marketplaceChecklistsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsAnswersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/answers/',
        ...options
    });
};
/**
 * Submit answer to checklist question
 */
export const marketplaceChecklistsAnswersSubmitCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/answers/submit/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsQuestionsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/questions/',
        ...options
    });
};
/**
 * Checklist stats per customer
 */
export const marketplaceChecklistsStatsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/stats/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceChecklistsUserAnswersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-checklists/{checklist_uuid}/user/{user_uuid}/answers/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceComponentUsagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-usages/',
        ...options
    });
};
export const marketplaceComponentUsagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-usages/{uuid}/',
        ...options
    });
};
export const marketplaceComponentUsagesSetUserUsage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-usages/{uuid}/set_user_usage/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceComponentUsagesSetUsage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-usages/set_usage/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceComponentUserUsagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-user-usages/',
        ...options
    });
};
export const marketplaceComponentUserUsagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-component-user-usages/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCustomerEstimatedCostPoliciesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/',
        ...options
    });
};
export const marketplaceCustomerEstimatedCostPoliciesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerEstimatedCostPoliciesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceCustomerEstimatedCostPoliciesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceCustomerEstimatedCostPoliciesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerEstimatedCostPoliciesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerEstimatedCostPoliciesActionsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-estimated-cost-policies/actions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceCustomerServiceAccountsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/',
        ...options
    });
};
export const marketplaceCustomerServiceAccountsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerServiceAccountsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceCustomerServiceAccountsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceCustomerServiceAccountsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerServiceAccountsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceCustomerServiceAccountsRotateApiKey = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-customer-service-accounts/{uuid}/rotate_api_key/',
        ...options
    });
};
/**
 * Count of resource categories for all resources accessible by user.
 */
export const marketplaceGlobalCategoriesRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-global-categories/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceIntegrationStatusesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-integration-statuses/',
        ...options
    });
};
export const marketplaceIntegrationStatusesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-integration-statuses/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceMaintenanceAnnouncementOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementOfferingsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementOfferingsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementOfferingsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementOfferingsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-offerings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceMaintenanceAnnouncementTemplateOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementTemplateOfferingsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementTemplateOfferingsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementTemplateOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementTemplateOfferingsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementTemplateOfferingsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcement-template-offerings/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceMaintenanceAnnouncementsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceMaintenanceAnnouncementsTemplateList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsTemplateCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementsTemplateDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsTemplateRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsTemplatePartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementsTemplateUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements-template/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/{uuid}/',
        ...options
    });
};
export const marketplaceMaintenanceAnnouncementsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceMaintenanceAnnouncementsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-maintenance-announcements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingEstimatedCostPoliciesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/',
        ...options
    });
};
export const marketplaceOfferingEstimatedCostPoliciesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingEstimatedCostPoliciesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingEstimatedCostPoliciesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingEstimatedCostPoliciesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingEstimatedCostPoliciesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List available actions for OfferingEstimatedCostPolicy
 */
export const marketplaceOfferingEstimatedCostPoliciesActionsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-estimated-cost-policies/actions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingFilesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-files/',
        ...options
    });
};
export const marketplaceOfferingFilesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-files/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingFilesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-files/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingFilesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-files/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingPermissionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-permissions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingPermissionsLogList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-permissions-log/',
        ...options
    });
};
export const marketplaceOfferingPermissionsLogRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-permissions-log/{id}/',
        ...options
    });
};
export const marketplaceOfferingPermissionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-permissions/{id}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingReferralsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-referrals/',
        ...options
    });
};
export const marketplaceOfferingReferralsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-referrals/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingUsagePoliciesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/',
        ...options
    });
};
export const marketplaceOfferingUsagePoliciesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUsagePoliciesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUsagePoliciesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUsagePoliciesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUsagePoliciesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUsagePoliciesActionsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-usage-policies/actions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingUserRolesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/',
        ...options
    });
};
export const marketplaceOfferingUserRolesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUserRolesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUserRolesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUserRolesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUserRolesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-user-roles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOfferingUsersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/',
        ...options
    });
};
export const marketplaceOfferingUsersCreate = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
export const marketplaceOfferingUsersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUsersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/{uuid}/',
        ...options
    });
};
export const marketplaceOfferingUsersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUsersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOfferingUsersUpdateRestricted = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-offering-users/{uuid}/update_restricted/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceOrdersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/',
        ...options
    });
};
export const marketplaceOrdersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOrdersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/',
        ...options
    });
};
export const marketplaceOrdersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/',
        ...options
    });
};
export const marketplaceOrdersApproveByConsumer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/approve_by_consumer/',
        ...options
    });
};
export const marketplaceOrdersApproveByProvider = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/approve_by_provider/',
        ...options
    });
};
export const marketplaceOrdersCancel = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/cancel/',
        ...options
    });
};
export const marketplaceOrdersOfferingRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/offering/',
        ...options
    });
};
export const marketplaceOrdersRejectByConsumer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/reject_by_consumer/',
        ...options
    });
};
export const marketplaceOrdersRejectByProvider = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/reject_by_provider/',
        ...options
    });
};
export const marketplaceOrdersSetStateDone = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/set_state_done/',
        ...options
    });
};
export const marketplaceOrdersSetStateErred = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/set_state_erred/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceOrdersSetStateExecuting = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/set_state_executing/',
        ...options
    });
};
export const marketplaceOrdersUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-orders/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplacePlanComponentsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plan-components/',
        ...options
    });
};
export const marketplacePlanComponentsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plan-components/{id}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplacePlansList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/',
        ...options
    });
};
export const marketplacePlansCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/',
        ...options
    });
};
export const marketplacePlansRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/',
        ...options
    });
};
export const marketplacePlansPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansArchive = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/archive/',
        ...options
    });
};
export const marketplacePlansDeleteOrganizationGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/delete_organization_groups/',
        ...options
    });
};
export const marketplacePlansUpdateOrganizationGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/update_organization_groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansUpdatePrices = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/update_prices/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansUpdateQuotas = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/{uuid}/update_quotas/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePlansUsageStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-plans/usage_stats/',
        ...options
    });
};
export const marketplacePluginsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        url: '/api/marketplace-plugins/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceProjectEstimatedCostPoliciesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/',
        ...options
    });
};
export const marketplaceProjectEstimatedCostPoliciesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectEstimatedCostPoliciesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceProjectEstimatedCostPoliciesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/{uuid}/',
        ...options
    });
};
export const marketplaceProjectEstimatedCostPoliciesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectEstimatedCostPoliciesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectEstimatedCostPoliciesActionsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-estimated-cost-policies/actions/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceProjectServiceAccountsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/',
        ...options
    });
};
export const marketplaceProjectServiceAccountsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectServiceAccountsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceProjectServiceAccountsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceProjectServiceAccountsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectServiceAccountsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProjectServiceAccountsRotateApiKey = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-service-accounts/{uuid}/rotate_api_key/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceProjectUpdateRequestsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-update-requests/',
        ...options
    });
};
export const marketplaceProjectUpdateRequestsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-update-requests/{uuid}/',
        ...options
    });
};
/**
 * Approve project update request
 */
export const marketplaceProjectUpdateRequestsApprove = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-update-requests/{uuid}/approve/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Reject project update request
 */
export const marketplaceProjectUpdateRequestsReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-project-update-requests/{uuid}/reject/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceProviderOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/',
        ...options
    });
};
export const marketplaceProviderOfferingsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceProviderOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/',
        ...options
    });
};
export const marketplaceProviderOfferingsActivate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/activate/',
        ...options
    });
};
/**
 * Add endpoint to offering.
 */
export const marketplaceProviderOfferingsAddEndpoint = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/add_endpoint/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsArchive = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/archive/',
        ...options
    });
};
/**
 * Get statistics for offering components.
 */
export const marketplaceProviderOfferingsComponentStatsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/component_stats/',
        ...options
    });
};
/**
 * Get costs for offering.
 */
export const marketplaceProviderOfferingsCostsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/costs/',
        ...options
    });
};
export const marketplaceProviderOfferingsCreateOfferingComponent = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/create_offering_component/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Get customers for offering.
 */
export const marketplaceProviderOfferingsCustomersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/customers/',
        ...options
    });
};
/**
 * Delete endpoint from offering.
 */
export const marketplaceProviderOfferingsDeleteEndpoint = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/delete_endpoint/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete offering image.
 */
export const marketplaceProviderOfferingsDeleteImage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/delete_image/',
        ...options
    });
};
/**
 * Delete organization groups for offering.
 */
export const marketplaceProviderOfferingsDeleteOrganizationGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/delete_organization_groups/',
        ...options
    });
};
/**
 * Delete offering thumbnail.
 */
export const marketplaceProviderOfferingsDeleteThumbnail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/delete_thumbnail/',
        ...options
    });
};
export const marketplaceProviderOfferingsDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsDraft = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/draft/',
        ...options
    });
};
/**
 * This endpoint provides a config file for GLauth
 * Example: https://github.com/glauth/glauth/blob/master/v2/sample-simple.cfg
 * It is assumed that the config is used by an external agent,
 * which synchronizes data from Waldur to GLauth
 */
export const marketplaceProviderOfferingsGlauthUsersConfigRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/glauth_users_config/',
        ...options
    });
};
export const marketplaceProviderOfferingsImportResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/import_resource/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List importable resources for offering.
 */
export const marketplaceProviderOfferingsImportableResourcesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/importable_resources/',
        ...options
    });
};
export const marketplaceProviderOfferingsListCustomerProjectsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/list_customer_projects/',
        ...options
    });
};
export const marketplaceProviderOfferingsListCustomerServiceAccountsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/list_customer_service_accounts/',
        ...options
    });
};
export const marketplaceProviderOfferingsListCustomerUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/list_customer_users/',
        ...options
    });
};
export const marketplaceProviderOfferingsListProjectServiceAccountsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/list_project_service_accounts/',
        ...options
    });
};
export const marketplaceProviderOfferingsListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/list_users/',
        ...options
    });
};
export const marketplaceProviderOfferingsMoveOffering = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/move_offering/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsOrdersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/orders/',
        ...options
    });
};
export const marketplaceProviderOfferingsOrdersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/orders/{order_uuid}/',
        ...options
    });
};
export const marketplaceProviderOfferingsPause = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/pause/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Refresh offering user usernames.
 */
export const marketplaceProviderOfferingsRefreshOfferingUsernames = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/refresh_offering_usernames/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsRemoveOfferingComponent = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/remove_offering_component/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsSetBackendMetadata = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/set_backend_metadata/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsStatsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/stats/',
        ...options
    });
};
export const marketplaceProviderOfferingsSync = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/sync/',
        ...options
    });
};
export const marketplaceProviderOfferingsUnpause = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/unpause/',
        ...options
    });
};
/**
 * Update offering attributes.
 */
export const marketplaceProviderOfferingsUpdateAttributes = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_attributes/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateDescription = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_description/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update offering image.
 */
export const marketplaceProviderOfferingsUpdateImage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_image/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateIntegration = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_integration/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateLocation = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_location/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateOfferingComponent = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_offering_component/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateOptions = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_options/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update organization groups for offering.
 */
export const marketplaceProviderOfferingsUpdateOrganizationGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_organization_groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateOverview = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_overview/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateResourceOptions = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_resource_options/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update offering thumbnail.
 */
export const marketplaceProviderOfferingsUpdateThumbnail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_thumbnail/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderOfferingsUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Check if user has access to offering.
 */
export const marketplaceProviderOfferingsUserHasResourceAccessRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/{uuid}/user_has_resource_access/',
        ...options
    });
};
export const marketplaceProviderOfferingsGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-offerings/groups/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceProviderResourcesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/',
        ...options
    });
};
export const marketplaceProviderResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/',
        ...options
    });
};
export const marketplaceProviderResourcesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderResourcesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderResourcesDetailsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/details/',
        ...options
    });
};
/**
 *
 * This endpoint provides a config file for GLauth.
 * Example: https://github.com/glauth/glauth/blob/master/v2/sample-simple.cfg
 * It is assumed that the config is used by an external agent,
 * which synchronizes data from Waldur to GLauth.
 *
 */
export const marketplaceProviderResourcesGlauthUsersConfigRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/glauth_users_config/',
        ...options
    });
};
/**
 * Move resource to another project.
 */
export const marketplaceProviderResourcesMoveResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/move_resource/',
        ...options
    });
};
export const marketplaceProviderResourcesOfferingRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/offering/',
        ...options
    });
};
export const marketplaceProviderResourcesOfferingForSubresourcesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/offering_for_subresources/',
        ...options
    });
};
export const marketplaceProviderResourcesPlanPeriodsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/plan_periods/',
        ...options
    });
};
/**
 * Refresh the last sync time for a resource.
 */
export const marketplaceProviderResourcesRefreshLastSync = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/refresh_last_sync/',
        ...options
    });
};
/**
 * Set the resource as erred.
 */
export const marketplaceProviderResourcesSetAsErred = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_as_erred/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set the resource as OK.
 */
export const marketplaceProviderResourcesSetAsOk = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_as_ok/',
        ...options
    });
};
/**
 * Set resource backend ID.
 */
export const marketplaceProviderResourcesSetBackendId = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_backend_id/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderResourcesSetBackendMetadata = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_backend_metadata/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderResourcesSetEndDateByProvider = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_end_date_by_provider/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set end date of the resource by staff.
 */
export const marketplaceProviderResourcesSetEndDateByStaff = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_end_date_by_staff/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceProviderResourcesSetLimits = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_limits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set slug for resource.
 */
export const marketplaceProviderResourcesSetSlug = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/set_slug/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Submit resource report.
 */
export const marketplaceProviderResourcesSubmitReport = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/submit_report/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return users connected to the project.
 */
export const marketplaceProviderResourcesTeamList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/team/',
        ...options
    });
};
/**
 * Create marketplace order for resource termination.
 */
export const marketplaceProviderResourcesTerminate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/terminate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete marketplace resource and related plugin resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const marketplaceProviderResourcesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-provider-resources/{uuid}/unlink/',
        ...options
    });
};
export const marketplacePublicApiCheckSignature = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-api/check_signature/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplacePublicApiSetUsage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-api/set_usage/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplacePublicOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-offerings/',
        ...options
    });
};
export const marketplacePublicOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-offerings/{uuid}/',
        ...options
    });
};
export const marketplacePublicOfferingsPlansList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-offerings/{uuid}/plans/',
        ...options
    });
};
export const marketplacePublicOfferingsPlansRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-public-offerings/{uuid}/plans/{plan_uuid}/',
        ...options
    });
};
export const marketplaceRelatedCustomersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-related-customers/{customer_uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceRemoteSynchronisationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/',
        ...options
    });
};
export const marketplaceRemoteSynchronisationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRemoteSynchronisationsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/{uuid}/',
        ...options
    });
};
export const marketplaceRemoteSynchronisationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/{uuid}/',
        ...options
    });
};
export const marketplaceRemoteSynchronisationsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRemoteSynchronisationsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRemoteSynchronisationsRunSynchronisation = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-remote-synchronisations/{uuid}/run_synchronisation/',
        ...options
    });
};
export const marketplaceResourceOfferingsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resource-offerings/{category_uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceResourceUsersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resource-users/',
        ...options
    });
};
export const marketplaceResourceUsersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resource-users/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceResourceUsersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resource-users/{uuid}/',
        ...options
    });
};
export const marketplaceResourceUsersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resource-users/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceResourcesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/',
        ...options
    });
};
export const marketplaceResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/',
        ...options
    });
};
export const marketplaceResourcesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceResourcesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceResourcesDetailsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/details/',
        ...options
    });
};
/**
 *
 * This endpoint provides a config file for GLauth.
 * Example: https://github.com/glauth/glauth/blob/master/v2/sample-simple.cfg
 * It is assumed that the config is used by an external agent,
 * which synchronizes data from Waldur to GLauth.
 *
 */
export const marketplaceResourcesGlauthUsersConfigRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/glauth_users_config/',
        ...options
    });
};
/**
 * Move resource to another project.
 */
export const marketplaceResourcesMoveResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/move_resource/',
        ...options
    });
};
export const marketplaceResourcesOfferingRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/offering/',
        ...options
    });
};
export const marketplaceResourcesOfferingForSubresourcesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/offering_for_subresources/',
        ...options
    });
};
export const marketplaceResourcesPlanPeriodsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/plan_periods/',
        ...options
    });
};
/**
 * Set end date of the resource by staff.
 */
export const marketplaceResourcesSetEndDateByStaff = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/set_end_date_by_staff/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Set slug for resource.
 */
export const marketplaceResourcesSetSlug = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/set_slug/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Create marketplace order for resource plan switch.
 */
export const marketplaceResourcesSwitchPlan = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/switch_plan/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return users connected to the project.
 */
export const marketplaceResourcesTeamList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/team/',
        ...options
    });
};
/**
 * Create marketplace order for resource termination.
 */
export const marketplaceResourcesTerminate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/terminate/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete marketplace resource and related plugin resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const marketplaceResourcesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/unlink/',
        ...options
    });
};
/**
 * Create marketplace order for resource limits update.
 */
export const marketplaceResourcesUpdateLimits = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/update_limits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update resource options.
 */
export const marketplaceResourcesUpdateOptions = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/{uuid}/update_options/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceResourcesSuggestName = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-resources/suggest_name/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceRobotAccountsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/',
        ...options
    });
};
export const marketplaceRobotAccountsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRobotAccountsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceRobotAccountsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/',
        ...options
    });
};
export const marketplaceRobotAccountsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRobotAccountsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRobotAccountsSetStateCreating = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/set_state_creating/',
        ...options
    });
};
export const marketplaceRobotAccountsSetStateDeleted = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/set_state_deleted/',
        ...options
    });
};
export const marketplaceRobotAccountsSetStateErred = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/set_state_erred/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceRobotAccountsSetStateOk = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/set_state_ok/',
        ...options
    });
};
export const marketplaceRobotAccountsSetStateRequestDeletion = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-robot-accounts/{uuid}/set_state_request_deletion/',
        ...options
    });
};
/**
 * Retrieve available runtime states for resources, optionally filtered by project and category.
 */
export const marketplaceRuntimeStatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-runtime-states/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceScreenshotsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/',
        ...options
    });
};
export const marketplaceScreenshotsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceScreenshotsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/{uuid}/',
        ...options
    });
};
export const marketplaceScreenshotsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/{uuid}/',
        ...options
    });
};
export const marketplaceScreenshotsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceScreenshotsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-screenshots/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceScriptAsyncDryRunList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-script-async-dry-run/',
        ...options
    });
};
export const marketplaceScriptAsyncDryRunRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-script-async-dry-run/{uuid}/',
        ...options
    });
};
export const marketplaceScriptDryRunAsyncRun = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-script-dry-run/{uuid}/async_run/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceScriptDryRunRun = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-script-dry-run/{uuid}/run/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * This view allows a user to trigger a pull operation for a marketplace script resource.
 * The user must be a service consumer and have access to the resource.
 * The pull operation is performed asynchronously using Celery.
 * Pull a marketplace script resource.
 */
export const marketplaceScriptSyncResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-script-sync-resource/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceSectionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/',
        ...options
    });
};
export const marketplaceSectionsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceSectionsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/{key}/',
        ...options
    });
};
export const marketplaceSectionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/{key}/',
        ...options
    });
};
export const marketplaceSectionsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/{key}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceSectionsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-sections/{key}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const marketplaceServiceProvidersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/',
        ...options
    });
};
export const marketplaceServiceProvidersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return customer projects of service provider.
 */
export const marketplaceServiceProvidersCustomerProjectsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/customer_projects/',
        ...options
    });
};
/**
 * Return customers of service provider.
 */
export const marketplaceServiceProvidersCustomersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/customers/',
        ...options
    });
};
/**
 * Return SSH keys of service provider.
 */
export const marketplaceServiceProvidersKeysList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/keys/',
        ...options
    });
};
/**
 * Return offerings of service provider.
 */
export const marketplaceServiceProvidersOfferingsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/offerings/',
        ...options
    });
};
/**
 * Return project permissions of service provider.
 */
export const marketplaceServiceProvidersProjectPermissionsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/project_permissions/',
        ...options
    });
};
/**
 * Return projects of service provider.
 */
export const marketplaceServiceProvidersProjectsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/projects/',
        ...options
    });
};
/**
 * Return customers that have access role for a specified user within service provider's scope.
 *
 * Checks for:
 * - Customers where user has direct permissions
 * - Customers with projects where user has project roles
 * - Customers related to service provider's resources
 *
 * If user UUID is invalid or missing, returns empty list.
 */
export const marketplaceServiceProvidersUserCustomersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/user_customers/',
        ...options
    });
};
/**
 * Return users of service provider.
 */
export const marketplaceServiceProvidersUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{service_provider_uuid}/users/',
        ...options
    });
};
export const marketplaceServiceProvidersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/',
        ...options
    });
};
export const marketplaceServiceProvidersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/',
        ...options
    });
};
export const marketplaceServiceProvidersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceServiceProvidersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceServiceProvidersAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return service provider API secret code.
 */
export const serviceProviderApiSecretCodeRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/api_secret_code/',
        ...options
    });
};
/**
 * Generate new service provider API secret code.
 */
export const serviceProviderApiSecretCodeGenerate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/api_secret_code/',
        ...options
    });
};
export const marketplaceServiceProvidersDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceServiceProvidersListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/list_users/',
        ...options
    });
};
export const marketplaceServiceProvidersRevenueList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/revenue/',
        ...options
    });
};
export const marketplaceServiceProvidersRobotAccountCustomersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/robot_account_customers/',
        ...options
    });
};
export const marketplaceServiceProvidersRobotAccountProjectsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/robot_account_projects/',
        ...options
    });
};
export const marketplaceServiceProvidersSetOfferingsUsername = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/set_offerings_username/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const marketplaceServiceProvidersStatRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/stat/',
        ...options
    });
};
export const marketplaceServiceProvidersUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-service-providers/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return component usages for current month.
 */
export const marketplaceStatsComponentUsagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/component_usages/',
        ...options
    });
};
/**
 * Return component usages per month.
 */
export const marketplaceStatsComponentUsagesPerMonthList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/component_usages_per_month/',
        ...options
    });
};
/**
 * Return component usages per project.
 */
export const marketplaceStatsComponentUsagesPerProjectList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/component_usages_per_project/',
        ...options
    });
};
/**
 * Count active resources grouped by offering.
 */
export const marketplaceStatsCountActiveResourcesGroupedByOfferingList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_active_resources_grouped_by_offering/',
        ...options
    });
};
/**
 * Count active resources grouped by offering country.
 */
export const marketplaceStatsCountActiveResourcesGroupedByOfferingCountryList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_active_resources_grouped_by_offering_country/',
        ...options
    });
};
/**
 * Count active resources grouped by organization group.
 */
export const marketplaceStatsCountActiveResourcesGroupedByOrganizationGroupList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_active_resources_grouped_by_organization_group/',
        ...options
    });
};
/**
 * Count projects grouped by provider and industry flag
 */
export const marketplaceStatsCountProjectsGroupedByProviderAndIndustryFlagList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_projects_grouped_by_provider_and_industry_flag/',
        ...options
    });
};
/**
 * Count projects grouped by provider and OECD code
 */
export const marketplaceStatsCountProjectsGroupedByProviderAndOecdList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_projects_grouped_by_provider_and_oecd/',
        ...options
    });
};
/**
 * Count projects of service providers.
 */
export const marketplaceStatsCountProjectsOfServiceProvidersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_projects_of_service_providers/',
        ...options
    });
};
/**
 * Count projects of service providers grouped by OECD.
 */
export const marketplaceStatsCountProjectsOfServiceProvidersGroupedByOecdList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_projects_of_service_providers_grouped_by_oecd/',
        ...options
    });
};
/**
 * Count unique users connected with active resources of service provider.
 */
export const marketplaceStatsCountUniqueUsersConnectedWithActiveResourcesOfServiceProviderList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_unique_users_connected_with_active_resources_of_service_provider/',
        ...options
    });
};
/**
 * Count users of service providers.
 */
export const marketplaceStatsCountUsersOfServiceProvidersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/count_users_of_service_providers/',
        ...options
    });
};
/**
 * Return count of customer members.
 */
export const marketplaceStatsCustomerMemberCountList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/customer_member_count/',
        ...options
    });
};
/**
 * Retrieve statistics about the number of offerings, grouped by category and service provider.
 */
export const marketplaceStatsOfferingsCounterStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/offerings_counter_stats/',
        ...options
    });
};
/**
 * Return project count per organization.
 */
export const marketplaceStatsOrganizationProjectCountList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/organization_project_count/',
        ...options
    });
};
/**
 * Return resource count per organization.
 */
export const marketplaceStatsOrganizationResourceCountList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/organization_resource_count/',
        ...options
    });
};
/**
 * Group project limits by industry flag.
 */
export const marketplaceStatsProjectsLimitsGroupedByIndustryFlagRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/projects_limits_grouped_by_industry_flag/',
        ...options
    });
};
/**
 * Group project limits by OECD code.
 */
export const marketplaceStatsProjectsLimitsGroupedByOecdRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/projects_limits_grouped_by_oecd/',
        ...options
    });
};
/**
 * Group project usages by industry flag.
 */
export const marketplaceStatsProjectsUsagesGroupedByIndustryFlagRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/projects_usages_grouped_by_industry_flag/',
        ...options
    });
};
/**
 * Group project usages by OECD code.
 */
export const marketplaceStatsProjectsUsagesGroupedByOecdRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/projects_usages_grouped_by_oecd/',
        ...options
    });
};
/**
 * Return resources limits per offering.
 */
export const marketplaceStatsResourcesLimitsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/resources_limits/',
        ...options
    });
};
/**
 * Total cost of active resources per offering.
 */
export const marketplaceStatsTotalCostOfActiveResourcesPerOfferingList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/marketplace-stats/total_cost_of_active_resources_per_offering/',
        ...options
    });
};
/**
 * Get media file
 */
export const mediaRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/media/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const notificationMessagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/',
        ...options
    });
};
export const notificationMessagesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const notificationMessagesTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/',
        ...options
    });
};
export const notificationMessagesTemplatesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesTemplatesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/{uuid}/',
        ...options
    });
};
export const notificationMessagesTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/{uuid}/',
        ...options
    });
};
export const notificationMessagesTemplatesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesTemplatesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesTemplatesOverride = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages-templates/{uuid}/override/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/',
        ...options
    });
};
export const notificationMessagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/',
        ...options
    });
};
export const notificationMessagesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const notificationMessagesDisable = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/disable/',
        ...options
    });
};
export const notificationMessagesEnable = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/notification-messages/{uuid}/enable/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackBackupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/',
        ...options
    });
};
export const openstackBackupsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/',
        ...options
    });
};
export const openstackBackupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/',
        ...options
    });
};
export const openstackBackupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackBackupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackBackupsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/pull/',
        ...options
    });
};
/**
 * Restore instance from backup
 */
export const openstackBackupsRestore = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/restore/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackBackupsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-backups/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackFlavorsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-flavors/',
        ...options
    });
};
export const openstackFlavorsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-flavors/{uuid}/',
        ...options
    });
};
export const openstackFlavorsUsageStatsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-flavors/usage_stats/',
        ...options
    });
};
/**
 * Status *DOWN* means that floating IP is not linked to a VM, status *ACTIVE* means that it is in use.
 */
export const openstackFloatingIpsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/',
        ...options
    });
};
export const openstackFloatingIpsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/',
        ...options
    });
};
export const openstackFloatingIpsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/',
        ...options
    });
};
/**
 * Attach floating IP to port
 */
export const openstackFloatingIpsAttachToPort = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/attach_to_port/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Detach floating IP from port
 */
export const openstackFloatingIpsDetachFromPort = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/detach_from_port/',
        ...options
    });
};
export const openstackFloatingIpsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackFloatingIpsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/unlink/',
        ...options
    });
};
/**
 * Update description of the floating IP
 */
export const openstackFloatingIpsUpdateDescription = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-floating-ips/{uuid}/update_description/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackImagesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-images/',
        ...options
    });
};
export const openstackImagesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-images/{uuid}/',
        ...options
    });
};
export const openstackImagesUsageStatsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-images/usage_stats/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackInstanceAvailabilityZonesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instance-availability-zones/',
        ...options
    });
};
export const openstackInstanceAvailabilityZonesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instance-availability-zones/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackInstancesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/',
        ...options
    });
};
export const openstackInstancesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/',
        ...options
    });
};
export const openstackInstancesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackInstancesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Create backup from instance
 */
export const openstackInstancesBackup = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/backup/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Change flavor of the instance
 */
export const openstackInstancesChangeFlavor = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/change_flavor/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Get console url for the instance
 */
export const openstackInstancesConsoleRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/console/',
        ...options
    });
};
/**
 * Get console log for the instance
 */
export const openstackInstancesConsoleLogRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/console_log/',
        ...options
    });
};
/**
 * Get a list of instance floating IPs
 */
export const openstackInstancesFloatingIpsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/floating_ips/',
        ...options
    });
};
/**
 * Get a list of instance ports
 */
export const openstackInstancesPortsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/ports/',
        ...options
    });
};
export const openstackInstancesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/pull/',
        ...options
    });
};
/**
 * Restart the instance
 */
export const openstackInstancesRestart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/restart/',
        ...options
    });
};
/**
 * Start the instance
 */
export const openstackInstancesStart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/start/',
        ...options
    });
};
/**
 * Stop the instance
 */
export const openstackInstancesStop = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/stop/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackInstancesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/unlink/',
        ...options
    });
};
/**
 * Update allowed address pairs of the instance
 */
export const openstackInstancesUpdateAllowedAddressPairs = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/update_allowed_address_pairs/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update floating IPs of the instance
 */
export const openstackInstancesUpdateFloatingIps = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/update_floating_ips/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update ports of the instance
 */
export const openstackInstancesUpdatePorts = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/update_ports/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update security groups of the instance
 */
export const openstackInstancesUpdateSecurityGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-instances/{uuid}/update_security_groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackMarketplaceTenantsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-marketplace-tenants/',
        ...options
    });
};
export const openstackMarketplaceTenantsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-marketplace-tenants/{uuid}/',
        ...options
    });
};
export const openstackMarketplaceTenantsCreateImage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-marketplace-tenants/{uuid}/create_image/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackMarketplaceTenantsUploadImageData = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-marketplace-tenants/{uuid}/upload_image_data/{image_id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackMigrationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/',
        ...options
    });
};
export const openstackMigrationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackMigrationsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/{uuid}/',
        ...options
    });
};
export const openstackMigrationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/{uuid}/',
        ...options
    });
};
export const openstackMigrationsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackMigrationsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-migrations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackNetworkRbacPoliciesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-network-rbac-policies/',
        ...options
    });
};
export const openstackNetworkRbacPoliciesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-network-rbac-policies/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackNetworksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/',
        ...options
    });
};
export const openstackNetworksDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/',
        ...options
    });
};
export const openstackNetworksRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/',
        ...options
    });
};
export const openstackNetworksPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackNetworksUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackNetworksCreateSubnet = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/create_subnet/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackNetworksPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/pull/',
        ...options
    });
};
/**
 * Create RBAC policy for the network
 */
export const openstackNetworksRbacPolicyCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/rbac_policy_create/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete RBAC policy for the network
 */
export const openstackNetworksRbacPolicyDeleteDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/rbac_policy_delete/{rbac_policy_uuid}/',
        ...options
    });
};
export const openstackNetworksSetMtu = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/set_mtu/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackNetworksUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-networks/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackPortsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/',
        ...options
    });
};
export const openstackPortsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackPortsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/',
        ...options
    });
};
export const openstackPortsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/',
        ...options
    });
};
export const openstackPortsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackPortsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Disable port.
 */
export const openstackPortsDisablePort = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/disable_port/',
        ...options
    });
};
/**
 * Disable port security for the port
 */
export const openstackPortsDisablePortSecurity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/disable_port_security/',
        ...options
    });
};
/**
 * Enable port.
 */
export const openstackPortsEnablePort = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/enable_port/',
        ...options
    });
};
/**
 * Enable port security for the port
 */
export const openstackPortsEnablePortSecurity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/enable_port_security/',
        ...options
    });
};
export const openstackPortsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackPortsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/unlink/',
        ...options
    });
};
/**
 * Update port IP address.
 */
export const openstackPortsUpdatePortIp = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/update_port_ip/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Update security groups of the port
 */
export const openstackPortsUpdateSecurityGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-ports/{uuid}/update_security_groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackRoutersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/',
        ...options
    });
};
export const openstackRoutersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackRoutersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/{uuid}/',
        ...options
    });
};
export const openstackRoutersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/{uuid}/',
        ...options
    });
};
/**
 * Add interface to router. Either subnet or port must be provided.
 */
export const openstackRoutersAddRouterInterface = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/{uuid}/add_router_interface/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Remove interface from router. Either subnet or port must be provided.
 */
export const openstackRoutersRemoveRouterInterface = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/{uuid}/remove_router_interface/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackRoutersSetRoutes = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-routers/{uuid}/set_routes/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackSecurityGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/',
        ...options
    });
};
export const openstackSecurityGroupsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/',
        ...options
    });
};
export const openstackSecurityGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/',
        ...options
    });
};
export const openstackSecurityGroupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSecurityGroupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSecurityGroupsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/pull/',
        ...options
    });
};
/**
 * Update security group rules
 */
export const openstackSecurityGroupsSetRules = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/set_rules/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackSecurityGroupsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-security-groups/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackServerGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/',
        ...options
    });
};
export const openstackServerGroupsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackServerGroupsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/',
        ...options
    });
};
export const openstackServerGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/',
        ...options
    });
};
export const openstackServerGroupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackServerGroupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackServerGroupsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackServerGroupsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-server-groups/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackSnapshotsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/',
        ...options
    });
};
export const openstackSnapshotsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/',
        ...options
    });
};
export const openstackSnapshotsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/',
        ...options
    });
};
export const openstackSnapshotsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSnapshotsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSnapshotsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/pull/',
        ...options
    });
};
/**
 * Get a list of snapshot restorations
 */
export const openstackSnapshotsRestorationsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/restorations/',
        ...options
    });
};
/**
 * Restore volume from snapshot
 */
export const openstackSnapshotsRestore = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/restore/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackSnapshotsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-snapshots/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackSubnetsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/',
        ...options
    });
};
export const openstackSubnetsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/',
        ...options
    });
};
export const openstackSubnetsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/',
        ...options
    });
};
export const openstackSubnetsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSubnetsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackSubnetsConnect = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/connect/',
        ...options
    });
};
export const openstackSubnetsDisconnect = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/disconnect/',
        ...options
    });
};
export const openstackSubnetsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackSubnetsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-subnets/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackTenantsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/',
        ...options
    });
};
export const openstackTenantsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackTenantsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/',
        ...options
    });
};
export const openstackTenantsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/',
        ...options
    });
};
export const openstackTenantsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackTenantsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Return a list of volumes from backend
 */
export const openstackTenantsBackendInstancesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/backend_instances/',
        ...options
    });
};
/**
 * Return a list of volumes from backend
 */
export const openstackTenantsBackendVolumesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/backend_volumes/',
        ...options
    });
};
/**
 * Change password for tenant user
 */
export const openstackTenantsChangePassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/change_password/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Create floating IP for tenant
 */
export const openstackTenantsCreateFloatingIp = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/create_floating_ip/',
        ...options
    });
};
/**
 * Create network for tenant
 */
export const openstackTenantsCreateNetwork = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/create_network/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackTenantsCreateSecurityGroup = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/create_security_group/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackTenantsCreateServerGroup = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/create_server_group/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackTenantsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/pull/',
        ...options
    });
};
/**
 * Trigger job to pull floating IPs from remote VPC
 */
export const openstackTenantsPullFloatingIps = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/pull_floating_ips/',
        ...options
    });
};
/**
 * It triggers celery job to pull quotas from remote VPC
 */
export const openstackTenantsPullQuotas = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/pull_quotas/',
        ...options
    });
};
/**
 * Trigger job to pull security groups from remote VPC
 */
export const openstackTenantsPullSecurityGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/pull_security_groups/',
        ...options
    });
};
/**
 * Trigger job to pull server groups from remote VPC
 */
export const openstackTenantsPullServerGroups = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/pull_server_groups/',
        ...options
    });
};
/**
 * A quota can be set for a particular tenant. Only staff users can do that.
 * In order to set quota submit POST request to /api/openstack-tenants/<uuid>/set_quotas/.
 * The quota values are propagated to the backend.
 *
 * The following quotas are supported. All values are expected to be integers:
 *
 * - instances - maximal number of created instances.
 * - ram - maximal size of ram for allocation. In MiB_.
 * - storage - maximal size of storage for allocation. In MiB_.
 * - vcpu - maximal number of virtual cores for allocation.
 * - security_group_count - maximal number of created security groups.
 * - security_group_rule_count - maximal number of created security groups rules.
 * - volumes - maximal number of created volumes.
 * - snapshots - maximal number of created snapshots.
 *
 * It is possible to update quotas by one or by submitting all the fields in one request.
 * Waldur will attempt to update the provided quotas. Please note, that if provided quotas are
 * conflicting with the backend (e.g. requested number of instances is below of the already existing ones),
 * some quotas might not be applied.
 *
 * .. _MiB: http://en.wikipedia.org/wiki/Mebibyte
 *
 * Response code of a successful request is **202 ACCEPTED**.
 * In case tenant is in a non-stable status, the response would be **409 CONFLICT**.
 * In this case REST client is advised to repeat the request after some time.
 * On successful completion the task will synchronize quotas with the backend.
 */
export const openstackTenantsSetQuotas = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/set_quotas/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackTenantsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-tenants/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackVolumeAvailabilityZonesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volume-availability-zones/',
        ...options
    });
};
export const openstackVolumeAvailabilityZonesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volume-availability-zones/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackVolumeTypesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volume-types/',
        ...options
    });
};
export const openstackVolumeTypesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volume-types/{uuid}/',
        ...options
    });
};
/**
 * Return a list of unique volume type names.
 */
export const openstackVolumeTypesNamesRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volume-types/names/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const openstackVolumesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/',
        ...options
    });
};
export const openstackVolumesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/',
        ...options
    });
};
export const openstackVolumesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackVolumesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Attach volume to instance
 */
export const openstackVolumesAttach = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/attach/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Detach instance from volume
 */
export const openstackVolumesDetach = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/detach/',
        ...options
    });
};
/**
 * Increase volume size
 */
export const openstackVolumesExtend = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/extend/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const openstackVolumesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/pull/',
        ...options
    });
};
/**
 * Retype detached volume
 */
export const openstackVolumesRetype = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/retype/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Create snapshot from volume
 */
export const openstackVolumesSnapshot = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/snapshot/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const openstackVolumesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/openstack-volumes/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const organizationGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/',
        ...options
    });
};
export const organizationGroupsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const organizationGroupsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/{uuid}/',
        ...options
    });
};
export const organizationGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/{uuid}/',
        ...options
    });
};
export const organizationGroupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const organizationGroupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/organization-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const overrideSettingsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/override-settings/',
        ...options
    });
};
export const overrideSettings = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/override-settings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const paymentProfilesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/',
        ...options
    });
};
export const paymentProfilesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const paymentProfilesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/{uuid}/',
        ...options
    });
};
export const paymentProfilesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/{uuid}/',
        ...options
    });
};
export const paymentProfilesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const paymentProfilesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const paymentProfilesEnable = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payment-profiles/{uuid}/enable/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const paymentsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/',
        ...options
    });
};
export const paymentsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const paymentsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/',
        ...options
    });
};
export const paymentsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/',
        ...options
    });
};
export const paymentsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const paymentsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Link a payment to an invoice. Payment can be linked to an invoice only if they belong to the same customer.
 */
export const paymentsLinkToInvoice = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/link_to_invoice/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Unlink a payment from an invoice. Remove connection between payment and existing linked invoice.
 */
export const paymentsUnlinkFromInvoice = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/payments/{uuid}/unlink_from_invoice/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const projectCreditsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/',
        ...options
    });
};
export const projectCreditsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectCreditsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/{uuid}/',
        ...options
    });
};
export const projectCreditsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/{uuid}/',
        ...options
    });
};
export const projectCreditsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectCreditsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-credits/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List project quotas.
 */
export const projectQuotasList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-quotas/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const projectTypesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-types/',
        ...options
    });
};
export const projectTypesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/project-types/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const projectsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/',
        ...options
    });
};
/**
 * A new project can be created by users with staff privilege (is_staff=True) or customer owners.
 * Project resource quota is optional.
 */
export const projectsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectsMarketplaceChecklistsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{project_uuid}/marketplace-checklists/',
        ...options
    });
};
/**
 * If a project has connected instances, deletion request will fail with 409 response code.
 */
export const projectsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/',
        ...options
    });
};
export const projectsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/',
        ...options
    });
};
export const projectsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectsAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectsDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const projectsListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/list_users/',
        ...options
    });
};
export const projectsMoveProject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/move_project/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * A list of users which can be added to the current project from other projects of the same customer.
 */
export const projectsOtherUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/other_users/',
        ...options
    });
};
/**
 * Return statistics about project resources usage
 */
export const projectsStatsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/stats/',
        ...options
    });
};
/**
 * Trigger user role sync for this project
 */
export const projectsSyncUserRoles = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/sync_user_roles/',
        ...options
    });
};
export const projectsUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/projects/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const promotionsCampaignsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/',
        ...options
    });
};
export const promotionsCampaignsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const promotionsCampaignsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/',
        ...options
    });
};
export const promotionsCampaignsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/',
        ...options
    });
};
export const promotionsCampaignsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Activate campaign.
 */
export const promotionsCampaignsActivate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/activate/',
        ...options
    });
};
/**
 * Return a list of orders for which the campaign is applied.
 */
export const promotionsCampaignsOrdersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/orders/',
        ...options
    });
};
/**
 * Return a list of resources for which the campaign is applied.
 */
export const promotionsCampaignsResourcesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/resources/',
        ...options
    });
};
/**
 * Terminate campaign.
 */
export const promotionsCampaignsTerminate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/promotions-campaigns/{uuid}/terminate/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalProposalsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/',
        ...options
    });
};
export const proposalProposalsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/',
        ...options
    });
};
export const proposalProposalsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/',
        ...options
    });
};
export const proposalProposalsAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Approve a proposal.
 */
export const proposalProposalsApprove = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/approve/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Attach document to proposal.
 */
export const proposalProposalsAttachDocument = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/attach_document/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/list_users/',
        ...options
    });
};
/**
 * Reject a proposal.
 */
export const proposalProposalsReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/reject/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List resources for a proposal.
 */
export const proposalProposalsResourcesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/',
        ...options
    });
};
/**
 * Create resource for a proposal.
 */
export const proposalProposalsResourcesSet = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsResourcesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/{obj_uuid}/',
        ...options
    });
};
export const proposalProposalsResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/{obj_uuid}/',
        ...options
    });
};
export const proposalProposalsResourcesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsResourcesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/resources/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Submit a proposal.
 */
export const proposalProposalsSubmit = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/submit/',
        ...options
    });
};
/**
 * Update project details of a proposal.
 */
export const proposalProposalsUpdateProjectDetails = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/update_project_details/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProposalsUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-proposals/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalProtectedCallsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/',
        ...options
    });
};
export const proposalProtectedCallsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/',
        ...options
    });
};
export const proposalProtectedCallsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/',
        ...options
    });
};
export const proposalProtectedCallsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Activate a call.
 */
export const proposalProtectedCallsActivate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/activate/',
        ...options
    });
};
export const proposalProtectedCallsAddUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/add_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Archive a call.
 */
export const proposalProtectedCallsArchive = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/archive/',
        ...options
    });
};
/**
 * Attach documents to call.
 */
export const proposalProtectedCallsAttachDocuments = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/attach_documents/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsDeleteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/delete_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Detach documents from call.
 */
export const proposalProtectedCallsDetachDocuments = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/detach_documents/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsListUsersList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/list_users/',
        ...options
    });
};
/**
 * List offerings for a call.
 */
export const proposalProtectedCallsOfferingsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/',
        ...options
    });
};
/**
 * Create offering for a call.
 */
export const proposalProtectedCallsOfferingsSet = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsOfferingsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsOfferingsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsOfferingsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/offerings/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List resource templates for a call.
 */
export const proposalProtectedCallsResourceTemplatesList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/',
        ...options
    });
};
/**
 * Create resource template for a call.
 */
export const proposalProtectedCallsResourceTemplatesSet = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsResourceTemplatesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsResourceTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsResourceTemplatesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsResourceTemplatesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/resource_templates/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List rounds for a call.
 */
export const proposalProtectedCallsRoundsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/',
        ...options
    });
};
/**
 * Create a round for a call.
 */
export const proposalProtectedCallsRoundsSet = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsRoundsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsRoundsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/{obj_uuid}/',
        ...options
    });
};
export const proposalProtectedCallsRoundsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsRoundsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/{obj_uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsRoundsClose = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/rounds/{obj_uuid}/close/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalProtectedCallsUpdateUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-protected-calls/{uuid}/update_user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalPublicCallsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-public-calls/',
        ...options
    });
};
export const proposalPublicCallsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-public-calls/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalRequestedOfferingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-offerings/',
        ...options
    });
};
export const proposalRequestedOfferingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-offerings/{uuid}/',
        ...options
    });
};
/**
 * Accept a requested offering.
 */
export const proposalRequestedOfferingsAccept = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-offerings/{uuid}/accept/',
        ...options
    });
};
/**
 * Cancel a requested offering.
 */
export const proposalRequestedOfferingsCancel = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-offerings/{uuid}/cancel/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalRequestedResourcesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-resources/',
        ...options
    });
};
export const proposalRequestedResourcesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-requested-resources/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const proposalReviewsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/',
        ...options
    });
};
export const proposalReviewsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalReviewsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/',
        ...options
    });
};
export const proposalReviewsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/',
        ...options
    });
};
export const proposalReviewsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const proposalReviewsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Accept a review, changing its state to IN_REVIEW.
 */
export const proposalReviewsAccept = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/accept/',
        ...options
    });
};
/**
 * Reject a review, changing its state to REJECTED.
 */
export const proposalReviewsReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/reject/',
        ...options
    });
};
/**
 * Submit a review, changing its state to SUBMITTED.
 */
export const proposalReviewsSubmit = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/proposal-reviews/{uuid}/submit/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const providerInvoiceItemsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/provider-invoice-items/',
        ...options
    });
};
export const providerInvoiceItemsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/provider-invoice-items/{id}/',
        ...options
    });
};
/**
 * Execute SQL query against readonly database
 */
export const query = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/query/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rabbitmqUserStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rabbitmq-user-stats/',
        ...options
    });
};
export const rabbitmqVhostStatsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rabbitmq-vhost-stats/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherAppsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/',
        ...options
    });
};
export const rancherAppsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherAppsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/',
        ...options
    });
};
export const rancherAppsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/',
        ...options
    });
};
export const rancherAppsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherAppsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherAppsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherAppsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-apps/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherCatalogsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/',
        ...options
    });
};
export const rancherCatalogsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherCatalogsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/{uuid}/',
        ...options
    });
};
export const rancherCatalogsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/{uuid}/',
        ...options
    });
};
export const rancherCatalogsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherCatalogsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherCatalogsRefresh = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-catalogs/{uuid}/refresh/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherClusterSecurityGroupsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-security-groups/',
        ...options
    });
};
export const rancherClusterSecurityGroupsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-security-groups/{uuid}/',
        ...options
    });
};
export const rancherClusterSecurityGroupsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-security-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClusterSecurityGroupsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-security-groups/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherClusterTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-templates/',
        ...options
    });
};
export const rancherClusterTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-cluster-templates/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherClustersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/',
        ...options
    });
};
export const rancherClustersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClustersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/',
        ...options
    });
};
export const rancherClustersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/',
        ...options
    });
};
export const rancherClustersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClustersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClustersCreateManagementSecurityGroup = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/create_management_security_group/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClustersImportYaml = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/import_yaml/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherClustersPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherClustersUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-clusters/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherHpasList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/',
        ...options
    });
};
export const rancherHpasCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherHpasDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/',
        ...options
    });
};
export const rancherHpasRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/',
        ...options
    });
};
export const rancherHpasPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherHpasUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherHpasPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherHpasUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/unlink/',
        ...options
    });
};
export const rancherHpasYamlRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/yaml/',
        ...options
    });
};
export const rancherHpasYamlUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-hpas/{uuid}/yaml/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherIngressesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/',
        ...options
    });
};
export const rancherIngressesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherIngressesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/',
        ...options
    });
};
export const rancherIngressesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/',
        ...options
    });
};
export const rancherIngressesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherIngressesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherIngressesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherIngressesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/unlink/',
        ...options
    });
};
export const rancherIngressesYamlRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/yaml/',
        ...options
    });
};
export const rancherIngressesYamlUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-ingresses/{uuid}/yaml/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherNamespacesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-namespaces/',
        ...options
    });
};
export const rancherNamespacesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-namespaces/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherNodesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/',
        ...options
    });
};
export const rancherNodesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherNodesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/',
        ...options
    });
};
export const rancherNodesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/',
        ...options
    });
};
/**
 * Returns console URL for the node.
 */
export const rancherNodesConsoleRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/console/',
        ...options
    });
};
/**
 * Returns console log for the node.
 */
export const rancherNodesConsoleLogRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/console_log/',
        ...options
    });
};
/**
 * Links node to OpenStack instance.
 */
export const rancherNodesLinkOpenstack = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/link_openstack/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherNodesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherNodesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/unlink/',
        ...options
    });
};
/**
 * Unlinks node from OpenStack instance.
 */
export const rancherNodesUnlinkOpenstack = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-nodes/{uuid}/unlink_openstack/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherProjectsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-projects/',
        ...options
    });
};
export const rancherProjectsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-projects/{uuid}/',
        ...options
    });
};
/**
 * Returns project's secrets.
 */
export const rancherProjectsSecretsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-projects/{uuid}/secrets/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherRoleTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-role-templates/',
        ...options
    });
};
export const rancherRoleTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-role-templates/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherServicesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/',
        ...options
    });
};
export const rancherServicesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherServicesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/',
        ...options
    });
};
export const rancherServicesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/',
        ...options
    });
};
export const rancherServicesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherServicesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherServicesPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const rancherServicesUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/unlink/',
        ...options
    });
};
export const rancherServicesYamlRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/yaml/',
        ...options
    });
};
export const rancherServicesYamlUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-services/{uuid}/yaml/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherTemplateVersionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-template-versions/{template_uuid}/{version}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-templates/',
        ...options
    });
};
export const rancherTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-templates/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherUsersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-users/',
        ...options
    });
};
export const rancherUsersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-users/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rancherWorkloadsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/',
        ...options
    });
};
export const rancherWorkloadsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherWorkloadsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/',
        ...options
    });
};
export const rancherWorkloadsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/',
        ...options
    });
};
export const rancherWorkloadsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherWorkloadsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rancherWorkloadsRedeploy = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/redeploy/',
        ...options
    });
};
export const rancherWorkloadsYamlRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/yaml/',
        ...options
    });
};
export const rancherWorkloadsYamlUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/rancher-workloads/{uuid}/yaml/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Allows to pull user details from remote eduTEAMS instance.
 */
export const remoteEduteams = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-eduteams/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Cancel termination order
 */
export const remoteWaldurApiCancelTermination = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/cancel_termination/{uuid}',
        ...options
    });
};
/**
 * Create local offering from remote
 */
export const remoteWaldurApiImportOffering = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/import_offering/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const remoteWaldurApiPullOfferingDetails = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_details/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingInvoices = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_invoices/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingOrders = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_orders/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingResources = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_resources/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingRobotAccounts = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_robot_accounts/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingUsage = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_usage/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiPullOfferingUsers = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_offering_users/{uuid}/',
        ...options
    });
};
/**
 * Schedule order pull task
 */
export const remoteWaldurApiPullOrder = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/pull_order/{uuid}',
        ...options
    });
};
export const remoteWaldurApiPushProjectData = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/push_project_data/{uuid}/',
        ...options
    });
};
/**
 * List remote marketplace categories
 */
export const remoteWaldurApiRemoteCategories = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/remote_categories/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List remote customers owned by current user
 */
export const remoteWaldurApiRemoteCustomers = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/remote_customers/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * List remote importable offerings for particular customer
 */
export const remoteWaldurApiSharedOfferings = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/shared_offerings/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const remoteWaldurApiSyncResource = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/sync_resource/{uuid}/',
        ...options
    });
};
export const remoteWaldurApiSyncResourceProjectPermissions = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/remote-waldur-api/sync_resource_project_permissions/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const rolesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/',
        ...options
    });
};
export const rolesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rolesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/',
        ...options
    });
};
export const rolesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/',
        ...options
    });
};
export const rolesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rolesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const rolesDisable = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/disable/',
        ...options
    });
};
export const rolesEnable = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/enable/',
        ...options
    });
};
export const rolesUpdateDescriptionsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/roles/{uuid}/update_descriptions/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const serviceSettingsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/service-settings/',
        ...options
    });
};
export const serviceSettingsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/service-settings/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const slurmAllocationUserUsageList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocation-user-usage/',
        ...options
    });
};
export const slurmAllocationUserUsageRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocation-user-usage/{id}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const slurmAllocationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/',
        ...options
    });
};
export const slurmAllocationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmAllocationsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/',
        ...options
    });
};
export const slurmAllocationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/',
        ...options
    });
};
export const slurmAllocationsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmAllocationsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmAllocationsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/pull/',
        ...options
    });
};
export const slurmAllocationsSetLimits = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/set_limits/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const slurmAllocationsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-allocations/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const slurmAssociationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-associations/',
        ...options
    });
};
export const slurmAssociationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-associations/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const slurmJobsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/',
        ...options
    });
};
export const slurmJobsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmJobsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/',
        ...options
    });
};
export const slurmJobsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/',
        ...options
    });
};
export const slurmJobsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmJobsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const slurmJobsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const slurmJobsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/slurm-jobs/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportAttachmentsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-attachments/',
        ...options
    });
};
export const supportAttachmentsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-attachments/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportAttachmentsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-attachments/{uuid}/',
        ...options
    });
};
export const supportAttachmentsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-attachments/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportCommentsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-comments/',
        ...options
    });
};
export const supportCommentsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-comments/{uuid}/',
        ...options
    });
};
export const supportCommentsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-comments/{uuid}/',
        ...options
    });
};
export const supportCommentsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-comments/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportCommentsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-comments/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportFeedbackAverageReportRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-feedback-average-report/',
        ...options
    });
};
export const supportFeedbackReportRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-feedback-report/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportFeedbacksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-feedbacks/',
        ...options
    });
};
export const supportFeedbacksCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-feedbacks/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportFeedbacksRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-feedbacks/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportIssuesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/',
        ...options
    });
};
export const supportIssuesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportIssuesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/',
        ...options
    });
};
export const supportIssuesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/',
        ...options
    });
};
export const supportIssuesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportIssuesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportIssuesComment = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/comment/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportIssuesSync = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-issues/{uuid}/sync/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportJiraWebhook = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/support-jira-webhook/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportPrioritiesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-priorities/',
        ...options
    });
};
export const supportPrioritiesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-priorities/{uuid}/',
        ...options
    });
};
export const supportSmaxWebhook = (options) => {
    return (options.client ?? _heyApiClient).post({
        url: '/api/support-smax-webhook/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportStatisticsRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-statistics/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/',
        ...options
    });
};
export const supportTemplatesCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportTemplatesDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/',
        ...options
    });
};
export const supportTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/',
        ...options
    });
};
export const supportTemplatesPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportTemplatesUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * This view attaches documents to template.
 */
export const supportTemplatesCreateAttachments = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/create_attachments/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const supportTemplatesDeleteAttachments = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-templates/{uuid}/delete_attachments/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const supportUsersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-users/',
        ...options
    });
};
export const supportUsersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/support-users/{uuid}/',
        ...options
    });
};
export const supportZammadWebhook = (options) => {
    return (options?.client ?? _heyApiClient).post({
        url: '/api/support-zammad-webhook/',
        ...options
    });
};
/**
 * This view triggers synchronization of issues from backend.
 */
export const syncIssuesRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/sync-issues/',
        ...options
    });
};
/**
 * This view triggers synchronization of issues from backend.
 */
export const syncIssues = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/sync-issues/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const userAgreementsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/',
        ...options
    });
};
export const userAgreementsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const userAgreementsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/{uuid}/',
        ...options
    });
};
export const userAgreementsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/{uuid}/',
        ...options
    });
};
export const userAgreementsPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const userAgreementsUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-agreements/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const userGroupInvitationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/',
        ...options
    });
};
export const userGroupInvitationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const userGroupInvitationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/{uuid}/',
        ...options
    });
};
/**
 * Cancel group invitation
 */
export const userGroupInvitationsCancel = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/{uuid}/cancel/',
        ...options
    });
};
/**
 * Return projects for group invitation
 */
export const userGroupInvitationsProjectsList = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/{uuid}/projects/',
        ...options
    });
};
export const userGroupInvitationsSubmitRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-group-invitations/{uuid}/submit_request/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const userInvitationsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/',
        ...options
    });
};
export const userInvitationsCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const userInvitationsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/',
        ...options
    });
};
/**
 * Accept invitation for current user.
 */
export const userInvitationsAccept = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/accept/',
        ...options
    });
};
export const userInvitationsCancel = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/cancel/',
        ...options
    });
};
export const userInvitationsCheck = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/check/',
        ...options
    });
};
export const userInvitationsDelete = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/delete/',
        ...options
    });
};
export const userInvitationsDetailsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/details/',
        ...options
    });
};
export const userInvitationsSend = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/{uuid}/send/',
        ...options
    });
};
/**
 * For user's convenience invitation approval is performed without authentication.
 * User UUID and invitation UUID is encoded into cryptographically signed token.
 */
export const userInvitationsApprove = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/approve/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * For user's convenience invitation reject action is performed without authentication.
 * User UUID and invitation UUID is encoded into cryptographically signed token.
 */
export const userInvitationsReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-invitations/reject/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const userPermissionRequestsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permission-requests/',
        ...options
    });
};
export const userPermissionRequestsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permission-requests/{uuid}/',
        ...options
    });
};
export const userPermissionRequestsApprove = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permission-requests/{uuid}/approve/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const userPermissionRequestsReject = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permission-requests/{uuid}/reject/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const userPermissionsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permissions/',
        ...options
    });
};
export const userPermissionsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/user-permissions/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const usersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/',
        ...options
    });
};
export const usersCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const usersMarketplaceChecklistStatsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{user_uuid}/marketplace-checklist-stats/',
        ...options
    });
};
export const usersDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/',
        ...options
    });
};
export const usersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/',
        ...options
    });
};
export const usersPartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const usersUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Cancel email update request
 */
export const usersCancelChangeEmail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/cancel_change_email/',
        ...options
    });
};
/**
 * Allows to change email for user.
 */
export const usersChangeEmail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/change_email/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Allows staff user to change password for any user.
 */
export const usersChangePassword = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/change_password/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Pulls remote user data from eduTEAMS.
 */
export const usersPullRemoteUser = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/pull_remote_user/',
        ...options
    });
};
/**
 * Allows to refresh user auth token.
 */
export const usersRefreshToken = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/refresh_token/',
        ...options
    });
};
export const usersTokenRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/{uuid}/token/',
        ...options
    });
};
/**
 * Confirm email update using code
 */
export const usersConfirmEmail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/confirm_email/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * Get current user details, including authentication token.
 */
export const usersMeRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/users/me/',
        ...options
    });
};
/**
 * Retrieve current version of the application and the latest available version from GitHub (if available).
 */
export const versionRetrieve = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/version/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareClustersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-clusters/',
        ...options
    });
};
export const vmwareClustersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-clusters/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareDatastoresList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-datastores/',
        ...options
    });
};
export const vmwareDatastoresRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-datastores/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareDisksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/',
        ...options
    });
};
export const vmwareDisksDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/{uuid}/',
        ...options
    });
};
export const vmwareDisksRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/{uuid}/',
        ...options
    });
};
/**
 * Increase disk capacity
 */
export const vmwareDisksExtend = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/{uuid}/extend/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const vmwareDisksPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const vmwareDisksUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-disks/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareFoldersList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-folders/',
        ...options
    });
};
export const vmwareFoldersRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-folders/{uuid}/',
        ...options
    });
};
export const vmwareLimitsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-limits/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareNetworksList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-networks/',
        ...options
    });
};
export const vmwareNetworksRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-networks/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwarePortsList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-ports/',
        ...options
    });
};
export const vmwarePortsDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-ports/{uuid}/',
        ...options
    });
};
export const vmwarePortsRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-ports/{uuid}/',
        ...options
    });
};
export const vmwarePortsPull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-ports/{uuid}/pull/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const vmwarePortsUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-ports/{uuid}/unlink/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareTemplatesList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-templates/',
        ...options
    });
};
export const vmwareTemplatesRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-templates/{uuid}/',
        ...options
    });
};
/**
 * Mixin to optimize HEAD requests for DRF views bypassing serializer processing
 */
export const vmwareVirtualMachineList = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/',
        ...options
    });
};
export const vmwareVirtualMachineCreate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const vmwareVirtualMachineDestroy = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/',
        ...options
    });
};
export const vmwareVirtualMachineRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/',
        ...options
    });
};
export const vmwareVirtualMachinePartialUpdate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const vmwareVirtualMachineUpdate = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
/**
 * This endpoint provides access to Virtual Machine Remote Console aka VMRC.
 */
export const vmwareVirtualMachineConsoleRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/console/',
        ...options
    });
};
export const vmwareVirtualMachineCreateDisk = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/create_disk/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const vmwareVirtualMachineCreatePort = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/create_port/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
export const vmwareVirtualMachinePull = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/pull/',
        ...options
    });
};
export const vmwareVirtualMachineRebootGuest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/reboot_guest/',
        ...options
    });
};
export const vmwareVirtualMachineReset = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/reset/',
        ...options
    });
};
export const vmwareVirtualMachineShutdownGuest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/shutdown_guest/',
        ...options
    });
};
export const vmwareVirtualMachineStart = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/start/',
        ...options
    });
};
export const vmwareVirtualMachineStop = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/stop/',
        ...options
    });
};
export const vmwareVirtualMachineSuspend = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/suspend/',
        ...options
    });
};
/**
 * Delete resource from the database without scheduling operations on backend
 * and without checking current state of the resource. It is intended to be used
 * for removing resource stuck in transitioning state.
 */
export const vmwareVirtualMachineUnlink = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/unlink/',
        ...options
    });
};
/**
 * This endpoint provides access to HTML Console aka WMKS.
 */
export const vmwareVirtualMachineWebConsoleRetrieve = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/vmware-virtual-machine/{uuid}/web_console/',
        ...options
    });
};
